import { gql } from '@apollo/client';

export const PRODUCT_TYPE_LIST = gql`
  query productTypeList {
    lobProductList {
      lob_name
      lob_code
      products {
        product_name
        product_code
        product_types {
          code
          value
        }
        linkTo
      }
    }
  }
`;

export const LOB_PRODUCT_LIST = gql`
  query lobProductList {
    lobProductList {
      lob_name
      lob_code
      products {
        product_name
        product_code
        linkTo
      }
    }
  }
`;

export const GET_DATE_TIME = gql`
  query getDateTime {
    datetimeValue {
      time
      date
    }
  }
`;

export const GET_BUY_FIRE_POLICY_VAR_DETAILS = gql`
  query getBuyFirePolicyDetails {
    buyFirePolicy @client
    selectedIntermediary @client
  }
`;

export const GET_BUY_FIRE_UPLOAD_POLICY_VAR_DETAILS = gql`
  query getBuyFireUploadPolicyVarDetails {
    fireQuoteUploadDocs @client {
      documentDetails
    }
  }
`;

export const PROPOSAL_PAYMENT_TYPE_LIST = gql`
  query proposalPaymentType {
    ProposalPaymentTypeList {
      code
      value
    }
  }
`;

export const DOWNLOAD_FIRE_PROPOSAL_PDF = gql`
  mutation firedownloadProposalForm($input: FireProposalInput ) {
    firedownloadProposalForm(input: $input) {
      base64Pdf
    }
  }
`;

export const SAVE_QUOTE_FIRE = gql`
  mutation saveQuote($input: FireQuoteInput) {
    saveQuoteFire(input: $input) {
      quoteCreationDate
      quoteNumber
      status
      stageIndex
    }
  }
`;

export const FINANCER_DROPDOWN_DETAILS = gql`
  query getDomainData($input: DomainInput) {
    getDomainData(input: $input) {
      code
      value
    }
  }
`;

export const GET_DEFAULT_CLAUSES = gql`
  query getDefaultClauses(
    $input: ClauseConditionExclusionWarrentyInput
  ) {
    getDefaultClauses(input: $input) {
      clauseCode
      clauseDescription
      clauseNumber
      default
      txtClauseType
      description
    }
  }
`;

export const GET_DEFAULT_CONDITIONS = gql`
  query getDefaultConditions(
    $input: ClauseConditionExclusionWarrentyInput
  ) {
    getDefaultConditions(input: $input) {
      conditionCode
      conditionShortDescription
      txtConditionNumber
      txtDefault
      txtConditionType
      description
    }
  }
`;

export const GET_DEFAULT_EXCLUSIONS = gql`
  query getDefaultExclusions(
    $input: ClauseConditionExclusionWarrentyInput
  ) {
    getDefaultExclusions(input: $input) {
      exclusionCode
      exclusionShortDescription
      txtExclusionNumber
      txtDefault
      txtExclusionType
      description
    }
  }
`;

export const GET_DEFAULT_WARRANTIES = gql`
  query getDefaultWarranties(
    $input: ClauseConditionExclusionWarrentyInput
  ) {
    getDefaultWarranties(input: $input) {
      warrantyCode
      warrantyShortDescription
      txtWarrantyNumber
      txtDefault
      txtWarrantyType
      description
    }
  }
`;

export const GET_DOCUMENTS_INFO = gql`
  query documentsInfo($input: IDInput) {
    documentList(input: $input) {
      code
      value
    }
  }
`;

export const DOCUMENT_STATIC_DATA = gql`
  query documentExtensions {
    documentExtensions {
      code
      value
    }
    docFileSizeLimit {
      code
      value
    }
    #docAddLimit {
    #code
    #value
    #}
    docDescCharacterLimit {
      code
      value
    }
  }
`;

export const SAVE_PROPOSAL_FIRE = gql`
  mutation saveProposalFire($input: FireProposalInput) {
    saveProposalFire(input: $input) {
      proposalNumber
      proposalEndDate
      proposalStatus
      isApplicableForPayment
      premium {
        locationNetPremium
        locationGST
        locationTotalPremium
        stampDuty
        warningMsg
      }
      customerID
      warningMsg
    }
  }
`;
export const FINANCER_DROPDOWN_DETAILS_FIRE = gql`
  query FireFinancierSearch($input: FinancierInput) {
    FireFinancierSearch(input: $input) {
      financier{
        bankCode
        bankName
      }
    }
  }
`;
export const CHECK_IMD_CONFIG = gql`
  query checkConfigImd($intermediaryCode: String){
    checkConfigImd( intermediaryCode: $intermediaryCode){
      isConfiguredIMD
    }
  }
`;
export const PROFILE_DETAILS = gql`
  query userMyDetail {
    userMyDetail {
      userId
      userType {
        typeName
      }
      profile {
        userImage
        firstName
        middleName
        lastName
        mobileNumber
        emailId
      }
      userCategory {
        categoryName
      }
      organisation {
        intermediaries {
          intermediaryName
          intermediaryCode
          isSelected
        }
      }
      status
    }
  }
`;
